






















































































































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { Status } from '@/api/models/Status'
import { StatusesMap } from '@/models/StatusesMap'
import { LabeledStatus } from '@/models/LabeledStatus'
import AccountOptions from '@/models/AccountOptions'
import { getDefaultAccountOptions } from '@/components/helper'

@Component
export default class StatusMapping extends Vue {
    @Prop({ type: Array, default: () => [] })
    private currentStatusesMappings!: Array<StatusesMap>

    @Prop({ type: Object, default: () => ({}) })
    private currentAccountOptions: AccountOptions

    @Prop({ type: Array, default: () => [] })
    private systemStatuses: Array<Status>

    @Prop({ type: Array, default: () => [] })
    private cdekStatuses: Array<Status>

    @Prop({ type: Array, default: () => [] })
    private systemProductStatuses: Array<Status>

    @Prop({ type: Array, default: () => [] })
    private systemPaymentStatuses: Array<Status>

    @Prop({ type: Boolean, default: true })
    private showItemsAndPaymentStatuses: boolean

    private selectedAccountOptions: AccountOptions = getDefaultAccountOptions()
    private selectedStatusesMappings: Array<StatusesMap> = []
    private labeledSystemStatuses: Array<LabeledStatus> = []

    @Watch('currentAccountOptions')
    selectedOptions(): void {
        this.selectedAccountOptions = Object.assign({}, this.currentAccountOptions)
    }

    @Watch('currentStatusesMappings')
    statusesMap() {
        this.selectedStatusesMappings = this.currentStatusesMappings.slice(0)
        this.labelSystemStatuses()
    }

    @Watch('systemStatuses')
    systemStatusesLoad() {
        this.labelSystemStatuses()
    }

    updateOption(code: string): void {
        if (this.selectedAccountOptions[code]) {
            this.$emit('updateAccountOptionEvent', this.selectedAccountOptions[code])
        }
    }

    created() {
        this.selectedStatusesMappings = this.currentStatusesMappings.slice(0)
        this.labelSystemStatuses()
    }

    labelSystemStatuses() {
        this.labeledSystemStatuses = this.systemStatuses.slice(0).map((status) => {
            return {
                name: status.name,
                code: status.code,
                label: status.name + ' (' + status.code + ')'
            } as LabeledStatus
        })
    }

    updateStatus(systemCode: string, cdekCode: string) {
        if (!systemCode) {
            this.clearStatus(cdekCode)
            this.$emit('updateStatusesMappings', { code: null, trackingStatusCode: cdekCode })

            return
        }

        let status = this.selectedStatusesMappings.find((item) => item.trackingStatusCode === cdekCode)

        if (!status) {
            status = { code: null, trackingStatusCode: cdekCode }
        }

        status.code = systemCode
        this.selectedStatusesMappings.push(status)
        this.$emit('updateStatusesMappings', status)
    }

    clearStatus(cdekCode: string): void {
        const index = this.selectedStatusesMappings.findIndex((item) => item.trackingStatusCode === cdekCode)
        this.selectedStatusesMappings.splice(index, 1)
    }

    valueCallback(cdekCode: string): Status|undefined {
        for (const status of this.selectedStatusesMappings) {
            if (status.trackingStatusCode === cdekCode) {
                return this.labeledSystemStatuses.find((item) => item.code === status.code)
            }
        }
    }

    cdekCodeReturn(code: string): string {
        return `${code}_RET`
    }
}
